import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import TagManager from 'react-gtm-module';
import _ from 'lodash';

import { TABLET_P } from '@/constants';
import searchIcon from '@/assets/images/search_jp.svg';
import plus from '@/assets/images/plus.svg';
import minus from '@/assets/images/minus.svg';
import Lines from './Lines';
import Spinner from '../../../components/Spinner';
import Placeholder from '../../../components/Placeholder';
import defaultCoords from "./Coords.json";
import {
  MainInner,
  SecTitle,
  Textsmall,
  RefineProductsPart,
  MinusPlusIcon,
  ClearButton,
  TwoContentTab,
  SearchButtonWrapper,
  SearchButton,
  SearchButtonText,
  MagnifyingGlassIconWrapper,
  FreeWord,
  SelectWrap,
  Hr,
  SelectOne,
  SelectTwo,
  Option,
  Spacer,
  SpinnerForSp,
} from './WithLines.style';

class SalonLocatorWithLines extends React.Component {
  static defaultProps = {
    copy: {},
    searchHandle: null,
    newLinesData: [],
    prefectures: [],
    locale: undefined,
    searched: false,
  };
  static propTypes = {
    copy: PropTypes.shape(),
    searchByAddress: PropTypes.func.isRequired,
    searchByLocation: PropTypes.func.isRequired,
    searchHandle: PropTypes.func,
    newLinesData: PropTypes.arrayOf(PropTypes.shape()),
    prefectures: PropTypes.arrayOf(PropTypes.shape()),
    locale: PropTypes.string,
    searched: PropTypes.bool,
    products: PropTypes.shape().isRequired,
  };

  state = {
    isShowLines: true,
    lineFilter: {
      // 最後に選択したラインナップのカテゴリ
      lineFieldId: '',
      // 選択した全ラインナップをまとめるための配列
      lines: [],
      // 選択したラインナップをカテゴリ毎にまとめるための配列
      linesObj: [],
    },
    curTab: null,
    prefVal: undefined,
    cityVal: '',
    selectOneOpen: false,
    isLocationSearching: false,
    isFreewordSearching: false,
    isPrefectureSearching: false,
    available: true,
    isSelectTwoDisabled: true,
    isOneSelect: false,
    searchWord: null,
    getAutoLocationFlg: false,
  };

  componentDidMount = () => {
    const { hash } = window.location;
    if (hash === '#location') {
      this.tabHandle('', 0);
      this.toggleLines();
      this.getUserLocation();
    }
  };

  onSecondCityChange = cityVal => {
    let selectCity = '';

    this.state.cities.forEach(({ id, city }) => {
      if (id === cityVal) {
        this.setState({ cityVal: city }, () => {});
        selectCity = city;
      }
    });

    const areaValue = `${this.state.prefecture},${selectCity}`;
    this.searchByPrefectures(areaValue);
  };

  /**
   * URLのパラメーター(key)を取得し、エリア検索を実行
   * @param {*} line 商品ラインナップ
   * @param {*} getParam URLパラメーター
   */
  getAutoLocation = (line, getParam) => {
    if ('key' in getParam) {
      const paramKey = getParam.key;
      const newLinesData = line;
      const addData = [];
      let param = [];
      param = paramKey.split('+');

      // 取得したパラメータがlineのkeyと一致するかを判定
      param.map(name => {
        line.some(val => {
          const { lineFieldId, lines } = val;

          // 取得したパラメータkey名がラインナップにある名前なのかを判定
          const linesIndex = lines.findIndex(line => line.key === name);
          if (linesIndex > -1) {
            const lineLabel = lines[linesIndex].label;
            const lineKey = lines[linesIndex].key;
            switch (lineKey) {
              case 'THE HAIR CARE':
                // THE HAIR CAREの場合、関連したアイテムも追加
                const index = newLinesData.findIndex(obj => obj.lineFieldId === 'lines_HairCare');
                const { lines } = newLinesData[index];
                lines.map(val2 => {
                  const lineLabel2 = val2.label;
                  const lineKey2 = val2.key;
                  if (lineKey2 !== 'SUBLIMIC' && lineKey2 !== 'SPA EXPERT') {
                    if (lineLabel2 === undefined) {
                      addData.push({ lineFieldId, label: undefined, key: lineKey2 });
                    } else {
                      addData.push({ lineFieldId, label: lineLabel2, key: lineKey2 });
                    }
                  }
                });
                break;

              default:
                addData.push({ lineFieldId, label: lineLabel, key: lineKey });
            }
            return true;
          }
        });
      });

      if (addData.length > 0) {
        let getLineFieldId = this.state.lineFilter.lineFieldId;
        let getLines = [...this.state.lineFilter.lines];
        let getLinesObj = [...this.state.lineFilter.linesObj];

        addData.map(val => {
          getLineFieldId = val.lineFieldId;
          if (val.label !== undefined) {
            getLines = [...getLines, val.key];
          }
          const linesObjIndex = getLinesObj.findIndex(obj => obj.lineFieldId === val.lineFieldId);
          if (linesObjIndex === -1) {
            getLinesObj = [...getLinesObj, { lineFieldId: val.lineFieldId, lines: [val.key] }];
          } else {
            getLinesObj[linesObjIndex].lines.push(val.key);
          }
        });

        const lineFilter = {
          lineFieldId: getLineFieldId,
          lines: getLines,
          linesObj: getLinesObj,
        };

        this.setState({
          lineFilter,
        });

        // 各言語の特定の緯度経度でエリア検索をする
        const { available } = this.state;
        const { locale } = this.props;

        if (available) {
          this.setState({
            isLocationSearching: true,
          });
          let data = null;
          if (lineFilter.linesObj.length > 0) {
            data = encodeURIComponent(JSON.stringify(lineFilter.linesObj));
          }
          const coords = defaultCoords[locale];
          const { latitude, longitude } = coords;
          this.props.searchByLocation(latitude, longitude, data, () => {
            this.setState({
              isLocationSearching: false,
            });
          });
        }
      }
    }
  };

  getListWithComma = () => {
    const { copy } = this.props;
    const { lineFilter } = this.state;
    const resultIndex = (lineFilter.lines && _.findIndex(lineFilter.lines, item => item === undefined)) || -1;

    if (lineFilter.lines.length > 0) {
      if (resultIndex !== -1) {
        lineFilter.lines.splice(resultIndex, 1);
      }
      return lineFilter.lines.join('、');
    }
    return copy.selected_line_text;
  };

  /**
   * 「現在地から検索する」押下時に呼ばれる。
   */
  getUserLocation = () => {
    const { available } = this.state;
    if (available) {
      this.setState({
        isLocationSearching: true,
      });
      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          const { lineFilter } = this.state;
          let data = null;
          if (lineFilter.linesObj.length > 0) {
            data = encodeURIComponent(JSON.stringify(lineFilter.linesObj));
          }
          this.props.searchByLocation(coords.latitude, coords.longitude, data, () => {
            this.setState({
              isLocationSearching: false,
            });
          });
        },
        ({ code }) => {
          if (code === 1 || code === 2) {
            this.setState({ available: false, isLocationSearching: false });
          }
        }
      );
    }
    TagManager.dataLayer({
      dataLayer: {
        event: 'salonlocator',
        sl_item: this.props.copy.use_current_location,
      },
    });
  };

  selectOneClick = () => {
    this.setState({
      selectOneOpen: !this.state.selectOneOpen,
    });
  };

  handlePrefectureChange = value => {
    const { prefectures } = this.props;
    this.setState({
      isSelectTwoDisabled: false,
      isOneSelect: true,
    });

    prefectures.forEach(({ prefectures }) => {
      prefectures.forEach(({ id, cities, prefecture }) => {
        if (id === value) {
          this.setState({ cities, prefecture, prefVal: value });
        }
      });
    });
  };

  searchByFreeWord = () => {
    let { lineFilter } = this.state;
    const { searchWord } = this.state;
    if (lineFilter.linesObj.length === 0) {
      // state に値渡しするのは本来禁止。setState をかますべき。
      lineFilter = null;
    } else {
      // state に値渡しするのは本来禁止。setState をかますべき。
      lineFilter = encodeURIComponent(JSON.stringify(lineFilter.linesObj));
    }
    this.setState({
      isFreewordSearching: true,
    });
    this.props.searchByAddress(searchWord, lineFilter, () => {
      this.setState({
        isFreewordSearching: false,
      });
    });
    TagManager.dataLayer({
      dataLayer: {
        event: 'salonlocator',
        sl_item: this.props.copy.search_from_freeward,
        sl_kw: searchWord,
      },
    });
  };

  searchByPrefectures = area => {
    let { lineFilter } = this.state;
    if (lineFilter.linesObj.length === 0) {
      lineFilter = null;
    } else {
      lineFilter = encodeURIComponent(JSON.stringify(this.state.lineFilter.linesObj));
    }
    this.setState({
      isPrefectureSearching: true,
    });
    this.props.searchByAddress(`${area}`, lineFilter, () => {
      this.setState({
        isPrefectureSearching: false,
      });
    });

    TagManager.dataLayer({
      dataLayer: {
        event: 'salonlocator',
        sl_item: this.props.copy.search_from_preference,
        sl_kw: area,
      },
    });
  };

  tabHandle = (e, curTab) => {
    this.setState({ curTab });
  };

  clearHandle = () => {
    this.setState({
      lineFilter: {
        lines: [],
      },
    });
  };

  /**
   * 「THE HAIR CARE」以外の、アクティブ状態のラインナップを押下した時に呼ばれる。
   */
  clickLineHandle = (lineCategory, line) => {
    const { lineFieldId } = lineCategory;
    const lineLabel = line.label;
    const lineKey = line.key;
    const addData = [];
    const delData = [];

    let getLineFieldId = this.state.lineFilter.lineFieldId;
    let getLines = [...this.state.lineFilter.lines];
    let getLinesObj = [...this.state.lineFilter.linesObj];

    switch (lineKey) {
      case 'THE HAIR CARE':
        // THE HAIR CAREの場合、関連したアイテムも追加 or 削除
        const { newLinesData } = this.props;
        if (getLines.includes(lineKey)) {
          const index = newLinesData.findIndex(obj => obj.lineFieldId === 'lines_HairCare');
          const { lines } = newLinesData[index];
          lines.map(val2 => {
            const lineLabel2 = val2.label;
            const lineKey2 = val2.key;
            if (lineKey2 !== 'SUBLIMIC' && lineKey2 !== 'SPA EXPERT') {
              delData.push({ lineFieldId, label: lineLabel2, key: lineKey2 });
            }
          });
        } else {
          const index = newLinesData.findIndex(obj => obj.lineFieldId === 'lines_HairCare');
          const { lines } = newLinesData[index];
          lines.map(val2 => {
            const lineLabel2 = val2.label;
            const lineKey2 = val2.key;
            if (lineKey2 !== 'SUBLIMIC' && lineKey2 !== 'SPA EXPERT') {
              if (lineLabel2 === undefined) {
                addData.push({ lineFieldId, label: undefined, key: lineKey2 });
              } else {
                addData.push({ lineFieldId, label: lineLabel2, key: lineKey2 });
              }
            }
          });
          TagManager.dataLayer({
            dataLayer: {
              event: 'salonlocator',
              sl_item: 'THE HAIR CARE',
            },
          });
        }
        break;

      default:
        if (getLines.includes(lineKey)) {
          delData.push({ lineFieldId, label: lineLabel, key: lineKey });
        } else {
          addData.push({ lineFieldId, label: lineLabel, key: lineKey });
          TagManager.dataLayer({
            dataLayer: {
              event: 'salonlocator',
              sl_item: lineLabel,
            },
          });
        }
    }

    // 追加
    if (addData.length > 0) {
      addData.map(val => {
        getLineFieldId = val.lineFieldId;
        if (!getLines.includes(val.key)) {
          if (val.label !== undefined) {
            getLines = [...getLines, val.key];
          }
          const linesObjIndex = getLinesObj.findIndex(obj => obj.lineFieldId === val.lineFieldId);
          if (linesObjIndex === -1) {
            getLinesObj = [...getLinesObj, { lineFieldId: val.lineFieldId, lines: [val.key] }];
          } else {
            getLinesObj[linesObjIndex].lines.push(val.key);
          }
        }
      });
    }

    // 削除
    if (delData.length > 0) {
      delData.map(val => {
        if (getLines.includes(val.key)) {
          getLines = getLines.filter(item => item !== val.key);
        }
        const index = getLinesObj.findIndex(obj => obj.lineFieldId === val.lineFieldId);
        if (index !== -1) {
          const linesIndex = getLinesObj[index].lines.findIndex(line => line === val.key);
          if (linesIndex !== -1) {
            getLinesObj[index].lines.splice(linesIndex, 1);
            if (getLinesObj[index].lines.length === 0) {
              getLinesObj.splice(index, 1);
            }
          }
        }
      });
    }

    const lineFilter = {
      lineFieldId: getLineFieldId,
      lines: getLines,
      linesObj: getLinesObj,
    };

    this.setState({
      lineFilter,
    });
  };

  tabHandle = (e, curTab) => {
    this.setState({ curTab });
  };

  toggleLines = () => {
    this.setState({ isShowLines: !this.state.isShowLines });
  };
  clearHandle = () => {
    this.setState({
      lineFilter: {
        lines: [],
        linesObj: [],
      },
    });
  };
  searchHandle = () => {
    const { searchHandle } = this.props;
    const { searchWord } = this.state;
    searchHandle(searchWord, this.lineFilter);
  };
  handleKeyUp = e => {
    if (e.key === 'Enter') {
      this.searchByFreeWord();
    }
  };

  render() {
    const {
      isShowLines,
      lineFilter,
      curTab,
      cities,
      cityVal,
      selectOneOpen,
      isLocationSearching,
      isFreewordSearching,
      isPrefectureSearching,
      prefVal,
      isSelectTwoDisabled,
      isOneSelect,
      available,
      getAutoLocationFlg,
    } = this.state;
    const { copy, prefectures, searched, newLinesData, locale, param, products } = this.props;
    const twoTabs = [copy.use_current_location, copy.search_from_freeward, copy.search_from_preference];
    const copyIsLoaded = Object.keys(copy).length;

    if (newLinesData.length > 0 && products) {
      const labelProducts = products;
      if (getAutoLocationFlg === false && labelProducts !== undefined) {
        this.getAutoLocation(newLinesData, param);
        this.setState({
          getAutoLocationFlg: true,
        });
      }
    }

    return (
      <MainInner>
        <SecTitle isShowLines={isShowLines}>
          {copyIsLoaded ? (
            <React.Fragment>
              <React.Fragment>1.</React.Fragment>
              {/* 「商品を絞り込む」表示部分 */}
              {copy.search_by_line_label}
              <RefineProductsPart onClick={this.toggleLines}>
                <MinusPlusIcon src={isShowLines ? minus : plus} />
              </RefineProductsPart>
              {/* 「選択条件をクリア」表示部分 (アイテムを選択した場合のみ表示される) */}
              {!!(_.get(lineFilter, 'lines') && lineFilter.lines.length > 0) && (
                <ClearButton onClick={this.clearHandle}>{copy.clear_condition}</ClearButton>
              )}
            </React.Fragment>
          ) : (
            <Placeholder w="30%" h="24px" />
          )}
        </SecTitle>

        {!!(_.get(lineFilter, 'lines') && lineFilter.lines.length >= 0) && (
          <Textsmall>
            {copyIsLoaded ? (
              <React.Fragment>
                {copy.selected_line_label}: {this.getListWithComma()}
              </React.Fragment>
            ) : (
              <Placeholder w="20%" h="16px" />
            )}
          </Textsmall>
        )}

        <Lines
          linesData={newLinesData || []}
          isShowLines={isShowLines}
          clickLine={this.clickLineHandle}
          currentLi={lineFilter.lines}
          copy={copy}
        />
        <Hr />
        <SecTitle>
          {copyIsLoaded ? (
            <React.Fragment>
              <div>2.</div>
              {copy.search_by_area_label}
              <SpinnerForSp>
                <Spinner className="spinnerForSp" c="black" show={isLocationSearching} />
                <Spinner className="spinnerForSp" c="black" show={isFreewordSearching} />
                <Spinner className="spinnerForSp" c="black" show={isPrefectureSearching} />
              </SpinnerForSp>
            </React.Fragment>
          ) : (
            <Placeholder w="30%" h="24px" />
          )}
        </SecTitle>

        <TwoContentTab available={available}>
          {/* 「現在地から検索する」表示部分 */}
          <SearchButtonWrapper
            onClick={e => {
              this.tabHandle(e, 0);
              this.getUserLocation();
            }}
          >
            <Spinner className="spinnerForPc" c="black" show={isLocationSearching} />
            <SearchButton className="location">
              {!twoTabs[0] ? (
                <Placeholder w={window.innerWidth > TABLET_P ? '140px' : '80px'} h="20px" />
              ) : (
                <SearchButtonText textDecoration={curTab === 0 ? 'underline' : 'none'}>{twoTabs[0]}</SearchButtonText>
              )}
            </SearchButton>
          </SearchButtonWrapper>
          {/* 「フリーワードから探す」表示部分 */}
          <SearchButtonWrapper onClick={e => this.tabHandle(e, 1)}>
            <Spinner className="spinnerForPc" c="black" show={isFreewordSearching} />
            <SearchButton>
              {!twoTabs[1] ? (
                <Placeholder w={window.innerWidth > TABLET_P ? '140px' : '80px'} h="20px" />
              ) : (
                <SearchButtonText textDecoration={curTab === 1 ? 'underline' : 'none'}>{twoTabs[1]}</SearchButtonText>
              )}
            </SearchButton>
          </SearchButtonWrapper>
          {/* 「都道府県から探す」表示部分 (日本のみ) */}
          {locale === 'ja_jp' && (
            <SearchButtonWrapper onClick={e => this.tabHandle(e, 2)}>
              <Spinner className="spinnerForPc" c="black" show={isPrefectureSearching} />
              <SearchButton>
                {!twoTabs[2] ? (
                  <Placeholder w={window.innerWidth > TABLET_P ? '140px' : '80px'} h="20px" />
                ) : (
                  <SearchButtonText textDecoration={curTab === 2 ? 'underline' : 'none'}>{twoTabs[2]}</SearchButtonText>
                )}
              </SearchButton>
            </SearchButtonWrapper>
          )}
        </TwoContentTab>
        {curTab === null && <Spacer />}
        {curTab === 0 && <Spacer />}
        {/* 「フリーワードから探す」を押下した時に表示される */}
        {curTab === 1 && (
          <FreeWord searched={searched}>
            {/* 検索キーワード入力フォーム */}
            <input
              type="text"
              onChange={event => {
                this.setState({ searchWord: event.target.value });
              }}
              placeholder={copy.address_prompt}
              onKeyUp={this.handleKeyUp}
            />
            {/* 虫眼鏡アイコン表示部分 */}
            <MagnifyingGlassIconWrapper tabIndex="0" onClick={() => this.searchByFreeWord()} onKeyUp={this.handleKeyUp}>
              <img src={searchIcon} alt="searchIcon" />
            </MagnifyingGlassIconWrapper>
          </FreeWord>
        )}

        {curTab === 2 && (
          <SelectWrap>
            <SelectOne
              defaultValue={copy.search_from_preference}
              onChange={this.handlePrefectureChange}
              selectOneOpen={selectOneOpen}
              onClick={this.selectOneClick}
            >
              {prefectures &&
                prefectures.map(({ prefectures }) =>
                  prefectures.map(({ id, prefecture }) => <Option key={id}>{prefecture}</Option>)
                )}
            </SelectOne>
            <SelectTwo
              value={cityVal || copy.select_local_place}
              onChange={this.onSecondCityChange}
              style={{ background: prefVal ? '#7c7c7c' : '#000000' }}
              disabled={isSelectTwoDisabled}
              isOneSelect={isOneSelect}
            >
              {(() => {
                // TODO: 不要であれば削除すること。
              })()}
              {cities && Array.isArray(cities) && cities.map(({ id, city }) => <Option key={id}>{city}</Option>)}
            </SelectTwo>
          </SelectWrap>
        )}
      </MainInner>
    );
  }
}

const mapState = state => ({
  locale: state.locale,
});
export default connect(mapState)(SalonLocatorWithLines);



// WEBPACK FOOTER //
// ./src/pages/SalonLocator/WithLines/WithLines.js